import "./_OrderSummaryGroup.scss";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useState } from "react";

export default function _OrderSummaryGroup() {
  const [showProof, setShowProof] = useState(false);

  return (
    <>
      <div className="osg-container">
        <div className="osg-downpayment-wrapper">
          <span>PAYMENT DETAILS</span>
          <div className="order-dtls-wrapper">
            <span>
              Purchase Number: <strong>PN-20250921-014</strong>
            </span>

            <span>
              Status: <strong>Partially Paid</strong>
            </span>
          </div>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Product Name</th>
                <th>Order No.</th>
                <th>Qty</th>
                <th>
                  Downpayment
                  <br /> (per unit)
                </th>
                <th>Downpayment Subtotal</th>
                <th>Unit Price</th>
                <th>Subtotal</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  `
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}Assets/Products/39/1756839829548846.jpg`}
                  />
                </td>
                <td className="productName">
                  THE IDOLM@STER GAKUEN ESPRESTO-SWEET MOMENT-RINAMI HIMESAKI
                </td>
                <td>PN-20250921-014</td>
                <td>2</td>
                <td>PHP 200</td>
                <td>PHP 400</td>
                <td>PHP 780</td>
                <td>PHP 1560</td>
              </tr>
              <tr>
                <td>
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}Assets/Products/39/1756839829548846.jpg`}
                  />
                </td>
                <td className="productName">
                  THE IDOLM@STER GAKUEN ESPRESTO-SWEET MOMENT-RINAMI HIMESAKI
                </td>
                <td>PN-20250921-014</td>
                <td>2</td>
                <td>PHP 200</td>
                <td>PHP 400</td>
                <td>PHP 780</td>
                <td>PHP 1560</td>
              </tr>
              <tr>
                <td className="division" colSpan={8}></td>
              </tr>
              <tr className="totals">
                <td colSpan={4}></td>
                <td>TOTAL DOWNPAYMENT:</td>
                <td>PHP 800</td>
                <td>TOTAL:</td>
                <td>PHP 3,120</td>
              </tr>
            </tbody>
          </table>
          {/* Expandable Downpayment Proof */}
          <div className="picture-dp-wrapper">
            <button
              onClick={() => setShowProof(!showProof)}
              className={showProof ? "open" : ""}
            >
              Downpayment Proof{" "}
              {showProof ? <FaChevronUp /> : <FaChevronDown />}
            </button>

            <div className={`dp-proof-content ${showProof ? "show" : ""}`}>
              <img
                src={`${process.env.REACT_APP_BASE_URL}Assets/Products/39/1756839829548846.jpg`}
                alt="Downpayment Proof"
              />
            </div>
          </div>{" "}
          <div className="picture-dp-wrapper">
            <button
              onClick={() => setShowProof(!showProof)}
              className={showProof ? "open" : ""}
            >
              Downpayment Proof{" "}
              {showProof ? <FaChevronUp /> : <FaChevronDown />}
            </button>

            <div className={`dp-proof-content ${showProof ? "show" : ""}`}>
              <img
                src={`${process.env.REACT_APP_BASE_URL}Assets/Products/39/1756839829548846.jpg`}
                alt="Downpayment Proof"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
